import { render } from "./DomainDrivenWorldModels.vue?vue&type=template&id=cc095854"
import script from "./DomainDrivenWorldModels.vue?vue&type=script&lang=js"
export * from "./DomainDrivenWorldModels.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/mehimself.github.io/mehimself.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__